export enum MemberRole {
  Staff = 0,
  Administrator = 1,
}

export enum TaskSummaryEmailMode {
  Off = 0,
  Daily = 1,
  Weekly = 2,
}

export enum OrganisationType {
  LimitedCompany = 'LimitedCompany',
  LimitedLiabilityPartnership = 'LimitedLiabilityPartnership',
  Partnership = 'Partnership',
  LimitedPartnership = 'LimitedPartnership',
  SoleTrader = 'SoleTrader',
  CIC = 'CIC',
  CharitableCompany = 'CharitableCompany',
  CIO = 'CIO',
  SCIO = 'SCIO',
  CharitableAssociation = 'CharitableAssociation',
  CharitableTrust = 'CharitableTrust',
}

export enum VatSchedule {
  JanAprJulOct = 0,
  FebMayAugNov = 1,
  MarJunSepDec = 2,
  Monthly = 3,
  Yearly = 4,
}

export enum MtdItQuarters {
  TaxYear = 0,
  Calendar = 1,
}

export enum VatDefaultPeriod {
  First = 0,
  Current = 1,
}

export enum BookkeepingFrequency {
  Weekly = 0,
  Monthly = 1,
  // WeeklyAndMonthly = 2,
  Quarterly = 3,
  Yearly = 4,
}

export enum PayrollFrequency {
  Weekly = 0,
  Fortnightly = 1,
  Monthly = 2,
  // WeeklyAndMonthly = 3,
  Quarterly = 4,
  Yearly = 5,
}

export enum JobScheduleType {
  OneOff = 0,
  // Daily = 1,
  // DailyWorkingDaysOnly = 2,
  Weekly = 3,
  // TwoWeekly = 4,
  // FourWeekly = 5,
  Monthly = 6,
  // TwoMonthly = 7,
  Quarterly = 8,
  // FourMonthly = 9,
  // SixMonthly = 10,
  Yearly = 11,
  // TwoYearly = 12,
  // ThreeYearly = 13,
  // FourYearly = 14,
  // FiveYearly = 15,
}

export enum TaskType {
  OneOff = 'OneOff',
  Recurring = 'Recurring',
  Smart = 'Smart',
}

export enum TaskStatus {
  Unscheduled = 'Unscheduled',
  Scheduled = 'Scheduled',
  StartDue = 'StartDue',
  Started = 'Started',
  CompletionDue = 'CompletionDue',
  Completed = 'Completed',
  DeadlineDue = 'DeadlineDue',
}

export enum RecordsStatus {
  Required = 'Required',
  Received = 'Received',
  NotRequired = 'NotRequired',
}

export enum MessageRuleDateType {
  RecordsReceived = 'RecordsReceived',
  PlannedStart = 'PlannedStart',
  ActualStart = 'ActualStart',
  PlannedComplete = 'PlannedComplete',
  ActualComplete = 'ActualComplete',
  Deadline = 'Deadline',
}

export enum MessageRuleCondition {
  RecordsRequired = 'RecordsRequired',
  NotStarted = 'NotStarted',
  Started = 'Started',
  NotCompleted = 'NotCompleted',
  Completed = 'Completed',
}

export enum RecurringTaskStatus {
  Scheduled = 'Scheduled',
  Completed = 'Completed',
}

export enum ClientType {
  Organisation = 'Client',
  Individual = 'Individual',
}

export enum IndividualRelationshipType {
  Client = 'Client',
  Contact = 'Contact',
  Prospect = 'Prospect',
}

export enum OrganisationRelationshipType {
  Client = 'Client',
  Prospect = 'Prospect',
}

export enum AmlStatus {
  NotStarted = 'NotStarted',
  NotLinked = 'NotLinked',
  NoAssessment = 'NoAssessment',
  InProgress = 'InProgress',
  InReview = 'InReview',
  Completed = 'Completed',
}

export enum AmlRiskLevel {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

export enum AmlProvider {
  XamaTech = 'XamaTech',
}

export enum AmlUpdateSource {
  Modal = 'modal',
}

export const RelationshipType = {
  ...OrganisationRelationshipType,
  ...IndividualRelationshipType,
};

export enum DueTimeFrameType {
  Accounts = 'Accounts',
  AmlCheck = 'AmlCheck',
  Bookkeeping = 'Bookkeeping',
  CisReturn = 'CisReturn',
  ConfirmationStatement = 'ConfirmationStatement',
  MtdItUpdate = 'MtdItUpdate',
  Payroll = 'Payroll',
  TaxReturn = 'TaxReturn',
  VatReturn = 'VatReturn',
}

export enum DueTimeFrame {
  Overdue = 'Overdue',
  Due = 'Due',
  DueToday = 'DueToday',
  DueTomorrow = 'DueTomorrow',
  DueThisWeek = 'DueThisWeek',
  DueNextWeek = 'DueNextWeek',
  DueThisMonth = 'DueThisMonth',
  DueNextMonth = 'DueNextMonth',
  DueMonthAfterNext = 'DueMonthAfterNext',
  DueWithin30Days = 'DueWithin30Days',
  DueWithin60Days = 'DueWithin60Days',
  DueWithin90Days = 'DueWithin90Days',
  DueWithin30To60Days = 'DueWithin30To60Days',
  DueWithin60To90Days = 'DueWithin60To90Days',
}

export enum DashboardView {
  OrganisationDeadlines = 'OrganisationDeadlines',
  TaskDeadlines = 'TaskDeadlines',
  PartnerTaskDeadlines = 'PartnerTaskDeadlines',
}
export enum OnboardingStep {
  SetUpUsers = 'SetUpUsers',
  AddCompanyClients = 'AddCompanyClients',
  AddIndividualClients = 'AddIndividualClients',
  ReviewSmartTasks = 'ReviewSmartTasks',
  CreateRecurringTask = 'CreateRecurringTask',
  CreateOneOffTask = 'CreateOneOffTask',
  AddChecklist = 'AddChecklist',
  StartAndCheckTaskStatus = 'StartAndCheckTaskStatus',
  AssignUsersToTasks = 'AssignUsersToTasks',
  CustomiseViews = 'CustomiseViews',
  SignUpTrial = 'SignUpTrial',
  CheckDashboard = 'CheckDashboard',
}
export type OnboardingSteps = Partial<Record<OnboardingStep, OnboardingStepStatus>>;

export enum OnboardingStepStatus {
  Done = 'Done',
  Dismissed = 'Dismissed',
}

export enum OrganisationSmartTaskType {
  AccountsPeriodEnd = 'AccountsPeriodEnd',
  AccountsDue = 'AccountsDue',
  AmlCheckDue = 'AmlCheckDue',
  BookkeepingDue = 'BookkeepingDue',
  OrganisationCreated = 'CompanyCreated', // SQL uses CompanyCreated
  CisPeriodEnd = 'CisPeriodEnd',
  CisReturnDue = 'CisReturnDue',
  ConfirmationStatementDue = 'ConfirmationStatementDue',
  CharityAnnualFilingDue = 'CharityAnnualFilingDue',
  EngagementSignatureRequired = 'EngagementSignatureRequired',
  PayrollDue = 'PayrollDue',
  TaxPeriodEnd = 'TaxPeriodEnd',
  TaxReturnDue = 'TaxReturnDue',
  TaxPaymentDue = 'TaxPaymentDue',
  VatPeriodEnd = 'VatPeriodEnd',
  VatReturnDue = 'VatReturnDue',
  MtdItPeriodEnd = 'MtdItPeriodEnd',
  MtdItUpdateDue = 'MtdItUpdateDue',
}

export enum IndividualSmartTaskType {
  AmlCheckDue = 'AmlCheckDue',
  EngagementSignatureRequired = 'EngagementSignatureRequired',
  IndividualCreated = 'IndividualCreated',
  TaxPeriodEnd = 'TaxPeriodEnd',
  TaxReturnDue = 'TaxReturnDue',
  MtdItPeriodEnd = 'MtdItPeriodEnd',
  MtdItUpdateDue = 'MtdItUpdateDue',
}

export enum SmartTaskFlag {
  MtdInScope = 'MtdInScope',
}

export const SmartTaskType = {
  ...OrganisationSmartTaskType,
  ...IndividualSmartTaskType,
};

export enum OrganisationUpdateOnCompletion {
  AccountsLastMadeUpTo = 'AccountsLastMadeUpTo',
  AmlLastChecked = 'AmlLastChecked',
  CisLastMadeUpTo = 'CisLastMadeUpTo',
  ConfirmationStatementLastMadeUpTo = 'ConfirmationStatementLastMadeUpTo',
  CharityAnnualFilingLastMadeUpTo = 'CharityAnnualFilingLastMadeUpTo',
  BookkeepingLastMadeUpTo = 'BookkeepingLastMadeUpTo',
  EngagementSigned = 'EngagementSigned',
  PayrollLastMadeUpTo = 'PayrollLastMadeUpTo',
  TaxReturnLastMadeUpTo = 'TaxLastMadeUpTo',
  TaxPaymentLastMadeUpTo = 'TaxLastPaidUpTo',
  VatLastMadeUpTo = 'VatLastMadeUpTo',
  MtdItLastMadeUpTo = 'MtdItLastMadeUpTo',
}

export enum IndividualUpdateOnCompletion {
  AmlLastChecked = 'AmlLastChecked',
  EngagementSigned = 'EngagementSigned',
  TaxReturnLastMadeUpTo = 'TaxLastMadeUpTo',
  MtdItLastMadeUpTo = 'MtdItLastMadeUpTo',
}

export const UpdateOnCompletion = {
  ...OrganisationUpdateOnCompletion,
  ...IndividualUpdateOnCompletion,
};

// PF1-3; The feature request only mentions Low, Medium, and High priorities.
// We've reserved space for one lower (Deferred) and one higher (Urgent) priority
// to allow future extension without breaking changes. These are currently commented out
// as they are not part of the current scope.
export enum Priority {
  // Deferred = 0,
  Low = 1,
  Medium = 2,
  High = 3,
  // Urgent = 4,
}

export enum FormFieldType {
  Text = 'Text',
  Number = 'Float',
  Boolean = 'Boolean',
  Date = 'Date',
  Dropdown = 'Dropdown',
}

export enum RequestType {
  ToDo = 'ToDo',
  Form = 'Form',
  Upload = 'Upload',
  Download = 'Download',
  Sign = 'Sign',
}

export enum RequestStatus {
  Pending = 'Pending',
  PendingApproval = 'Pending Approval',
  Draft = 'Draft',
  Completed = 'Completed',
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export enum DocumentLocation {
  ClientDocuments = 'ClientDocuments',
  TaskDocuments = 'TaskDocuments',
  Portal = 'Portal',
}

export enum AccountDeletionReason {
  Inactivity = 'INACTIVITY',
  GdprErasure = 'GDPR_ERASURE',
}
